export default "__VITE_ASSET__Dnlji$Oo__"